import produce from 'immer';
import {
  NOTIFICATION_UPDATE,
  NOTIFICATION_CLEAR_CHANNEL,
} from '../../actionTypes/notifications';
import { PayloadFromCreator } from '../../utils/types';
import {
  clearChannelNotificationsAction,
  notificationUpdateAction,
} from '../../actions/notifications';
import { isNil } from 'lodash';

export default (state: any = {}, action: any) =>
  produce(state, (draft: any) => {
    switch (action.type) {
      case NOTIFICATION_UPDATE: {
        const notifications = action.payload as PayloadFromCreator<
          typeof notificationUpdateAction
        >;
        return notifications?.wsNotifications.reduce(
          (obj: any, currentNotification: any) => {
            const channelNotifications =
              currentNotification.channelNotifications.reduce(
                (channelObj: any, currentChannel: any) => {
                  channelObj[currentChannel.channelId] = currentChannel;
                  return channelObj;
                },
                {},
              );
            obj[currentNotification.wsId] = {
              ...currentNotification,
              channelNotifications,
            };
            return obj;
          },
          {},
        );
      }
      case NOTIFICATION_CLEAR_CHANNEL: {
        const { workspaceId, channelId } = action.payload as PayloadFromCreator<
          typeof clearChannelNotificationsAction
        >;
        if (!isNil(workspaceId) && !isNil(channelId)) {
          delete draft?.[workspaceId]?.channelNotifications?.[channelId];
        }
        return;
      }
    }
  });
